// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PortalIdRouteRouteImport } from './routes/$portalId/route'
import { Route as NgosRouteRouteImport } from './routes/ngos/route'
import { Route as OldRouteRouteImport } from './routes/old/route'
import { Route as WwwRouteRouteImport } from './routes/www/route'
import { Route as PortalIdIndexRouteImport } from './routes/$portalId/index'
import { Route as PortalIdLegalDisclaimerRouteImport } from './routes/$portalId/legal-disclaimer'
import { Route as PortalIdPrivacyPolicyRouteImport } from './routes/$portalId/privacy-policy'
import { Route as NgosIndexRouteImport } from './routes/ngos/index'
import { Route as NgosDashboardRouteImport } from './routes/ngos/dashboard'
import { Route as NgosFaqRouteImport } from './routes/ngos/faq'
import { Route as NgosLoginRouteImport } from './routes/ngos/login'
import { Route as NgosOnboardingRouteRouteImport } from './routes/ngos/onboarding.route'
import { Route as NgosPortalsRouteRouteImport } from './routes/ngos/portals.route'
import { Route as NgosProjectsRouteRouteImport } from './routes/ngos/projects.route'
import { Route as NgosResourcesRouteImport } from './routes/ngos/resources'
import { Route as NgosSelectNgoRouteImport } from './routes/ngos/select-ngo'
import { Route as NgosSettingsRouteImport } from './routes/ngos/settings'
import { Route as OldIndexRouteImport } from './routes/old/index'
import { Route as OldSplatRouteImport } from './routes/old/$'
import { Route as OldAboutUsRouteImport } from './routes/old/about-us'
import { Route as OldContactRouteImport } from './routes/old/contact'
import { Route as OldCookiesRouteImport } from './routes/old/cookies'
import { Route as OldLegalDisclaimerRouteImport } from './routes/old/legal-disclaimer'
import { Route as OldPrivacyPolicyRouteImport } from './routes/old/privacy-policy'
import { Route as OldRoundUpRouteImport } from './routes/old/round-up'
import { Route as OldSelectionCriteriaRouteImport } from './routes/old/selection-criteria'
import { Route as OldTransparencyRouteImport } from './routes/old/transparency'
import { Route as WwwIndexRouteImport } from './routes/www/index'
import { Route as WwwSplatRouteImport } from './routes/www/$'
import { Route as WwwDotinternalRouteRouteImport } from './routes/www/[.]internal/route'
import { Route as WwwAboutUsRouteImport } from './routes/www/about-us'
import { Route as WwwContactRouteImport } from './routes/www/contact'
import { Route as WwwCookiesRouteImport } from './routes/www/cookies'
import { Route as WwwFaqRouteImport } from './routes/www/faq'
import { Route as WwwLegalDisclaimerRouteImport } from './routes/www/legal-disclaimer'
import { Route as WwwLiveCounterRouteImport } from './routes/www/live-counter'
import { Route as WwwPartnerNgosRouteImport } from './routes/www/partner-ngos'
import { Route as WwwPrivacyPolicyRouteImport } from './routes/www/privacy-policy'
import { Route as WwwSelectionCriteriaRouteImport } from './routes/www/selection-criteria'
import { Route as WwwSolutionsRouteImport } from './routes/www/solutions'
import { Route as PortalIdCampaignIdIndexRouteImport } from './routes/$portalId/$campaignId.index'
import { Route as PortalIdCampaignIdDonateRouteImport } from './routes/$portalId/$campaignId.donate'
import { Route as NgosOnboardingIndexRouteImport } from './routes/ngos/onboarding.index'
import { Route as NgosOnboardingAccreditationRouteImport } from './routes/ngos/onboarding.accreditation'
import { Route as NgosOnboardingContactsRouteImport } from './routes/ngos/onboarding.contacts'
import { Route as NgosOnboardingPrivacyRouteImport } from './routes/ngos/onboarding.privacy'
import { Route as NgosOnboardingSuccessRouteImport } from './routes/ngos/onboarding.success'
import { Route as NgosOnboardingTermsRouteImport } from './routes/ngos/onboarding.terms'
import { Route as NgosPortalsIndexRouteImport } from './routes/ngos/portals.index'
import { Route as NgosPortalsPortalIdRouteRouteImport } from './routes/ngos/portals.$portalId.route'
import { Route as NgosProjectsIndexRouteImport } from './routes/ngos/projects.index'
import { Route as NgosProjectsProjectIdRouteImport } from './routes/ngos/projects.$projectId'
import { Route as NgosProjectsNewRouteRouteImport } from './routes/ngos/projects.new.route'
import { Route as WwwDotinternalArchitectureRouteImport } from './routes/www/[.]internal/architecture'
import { Route as WwwDotinternalBumpRouteImport } from './routes/www/[.]internal/bump'
import { Route as WwwDotinternalCounterRouteImport } from './routes/www/[.]internal/counter'
import { Route as WwwDotinternalToastRouteImport } from './routes/www/[.]internal/toast'
import { Route as WwwContactIndexRouteImport } from './routes/www/contact.index'
import { Route as WwwContactAudienceRouteImport } from './routes/www/contact.$audience'
import { Route as WwwPartnerNgosIndexRouteImport } from './routes/www/partner-ngos.index'
import { Route as WwwPartnerNgosNgoIdRouteImport } from './routes/www/partner-ngos.$ngoId'
import { Route as PortalIdCampaignIdDonateIndexRouteImport } from './routes/$portalId/$campaignId.donate.index'
import { Route as PortalIdCampaignIdDonateCheckoutRouteImport } from './routes/$portalId/$campaignId.donate.checkout'
import { Route as PortalIdCampaignIdDonateDetailsRouteImport } from './routes/$portalId/$campaignId.donate.details'
import { Route as PortalIdCampaignIdDonateThanksRouteImport } from './routes/$portalId/$campaignId.donate.thanks'
import { Route as NgosContractsContractIdSignRouteImport } from './routes/ngos/contracts.$contractId.sign'
import { Route as NgosPortalsPortalIdIndexRouteImport } from './routes/ngos/portals.$portalId.index'
import { Route as NgosPortalsPortalIdSetupRouteRouteImport } from './routes/ngos/portals.$portalId_.setup.route'
import { Route as NgosProjectsNewIndexRouteImport } from './routes/ngos/projects.new.index'
import { Route as NgosProjectsNewBasicRouteImport } from './routes/ngos/projects.new.basic'
import { Route as NgosProjectsNewDetailsRouteImport } from './routes/ngos/projects.new.details'
import { Route as NgosProjectsNewFundingDetailsRouteImport } from './routes/ngos/projects.new.funding-details'
import { Route as NgosProjectsNewFundingTypeRouteImport } from './routes/ngos/projects.new.funding-type'
import { Route as NgosProjectsNewSuccessRouteImport } from './routes/ngos/projects.new.success'
import { Route as WwwContactAudienceIndexRouteImport } from './routes/www/contact.$audience.index'
import { Route as WwwContactAudienceTabRouteImport } from './routes/www/contact.$audience.$tab'
import { Route as NgosPortalsPortalIdProjectsProjectIdRouteImport } from './routes/ngos/portals.$portalId_.projects.$projectId'
import { Route as NgosPortalsPortalIdProjectsNewRouteRouteImport } from './routes/ngos/portals.$portalId_.projects.new.route'
import { Route as NgosPortalsPortalIdSetupIndexRouteImport } from './routes/ngos/portals.$portalId_.setup.index'
import { Route as NgosPortalsPortalIdSetupDetailsRouteImport } from './routes/ngos/portals.$portalId_.setup.details'
import { Route as NgosPortalsPortalIdSetupExtrasRouteImport } from './routes/ngos/portals.$portalId_.setup.extras'
import { Route as NgosPortalsPortalIdSetupFundingRouteImport } from './routes/ngos/portals.$portalId_.setup.funding'
import { Route as NgosPortalsPortalIdSetupSuccessRouteImport } from './routes/ngos/portals.$portalId_.setup.success'
import { Route as NgosPortalsPortalIdProjectsNewIndexRouteImport } from './routes/ngos/portals.$portalId_.projects.new.index'
import { Route as NgosPortalsPortalIdProjectsNewBasicRouteImport } from './routes/ngos/portals.$portalId_.projects.new.basic'
import { Route as NgosPortalsPortalIdProjectsNewDetailsRouteImport } from './routes/ngos/portals.$portalId_.projects.new.details'
import { Route as NgosPortalsPortalIdProjectsNewFundingDetailsRouteImport } from './routes/ngos/portals.$portalId_.projects.new.funding-details'
import { Route as NgosPortalsPortalIdProjectsNewSuccessRouteImport } from './routes/ngos/portals.$portalId_.projects.new.success'

const PortalIdRouteRoute = PortalIdRouteRouteImport.update({
            id: '/$portalId',path: '/$portalId',getParentRoute: () => rootRouteImport
          })
const NgosRouteRoute = NgosRouteRouteImport.update({
            id: '/ngos',path: '/ngos',getParentRoute: () => rootRouteImport
          })
const OldRouteRoute = OldRouteRouteImport.update({
            id: '/old',path: '/old',getParentRoute: () => rootRouteImport
          })
const WwwRouteRoute = WwwRouteRouteImport.update({
            id: '/www',path: '/www',getParentRoute: () => rootRouteImport
          })
const PortalIdIndexRoute = PortalIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortalIdRouteRoute
          })
const PortalIdLegalDisclaimerRoute = PortalIdLegalDisclaimerRouteImport.update({
            id: '/legal-disclaimer',path: '/legal-disclaimer',getParentRoute: () => PortalIdRouteRoute
          })
const PortalIdPrivacyPolicyRoute = PortalIdPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => PortalIdRouteRoute
          })
const NgosIndexRoute = NgosIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NgosRouteRoute
          })
const NgosDashboardRoute = NgosDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => NgosRouteRoute
          })
const NgosFaqRoute = NgosFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => NgosRouteRoute
          })
const NgosLoginRoute = NgosLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => NgosRouteRoute
          })
const NgosOnboardingRouteRoute = NgosOnboardingRouteRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => NgosRouteRoute
          })
const NgosPortalsRouteRoute = NgosPortalsRouteRouteImport.update({
            id: '/portals',path: '/portals',getParentRoute: () => NgosRouteRoute
          })
const NgosProjectsRouteRoute = NgosProjectsRouteRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => NgosRouteRoute
          })
const NgosResourcesRoute = NgosResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => NgosRouteRoute
          })
const NgosSelectNgoRoute = NgosSelectNgoRouteImport.update({
            id: '/select-ngo',path: '/select-ngo',getParentRoute: () => NgosRouteRoute
          })
const NgosSettingsRoute = NgosSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => NgosRouteRoute
          })
const OldIndexRoute = OldIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OldRouteRoute
          })
const OldSplatRoute = OldSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => OldRouteRoute
          })
const OldAboutUsRoute = OldAboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => OldRouteRoute
          })
const OldContactRoute = OldContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => OldRouteRoute
          })
const OldCookiesRoute = OldCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => OldRouteRoute
          })
const OldLegalDisclaimerRoute = OldLegalDisclaimerRouteImport.update({
            id: '/legal-disclaimer',path: '/legal-disclaimer',getParentRoute: () => OldRouteRoute
          })
const OldPrivacyPolicyRoute = OldPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => OldRouteRoute
          })
const OldRoundUpRoute = OldRoundUpRouteImport.update({
            id: '/round-up',path: '/round-up',getParentRoute: () => OldRouteRoute
          })
const OldSelectionCriteriaRoute = OldSelectionCriteriaRouteImport.update({
            id: '/selection-criteria',path: '/selection-criteria',getParentRoute: () => OldRouteRoute
          })
const OldTransparencyRoute = OldTransparencyRouteImport.update({
            id: '/transparency',path: '/transparency',getParentRoute: () => OldRouteRoute
          })
const WwwIndexRoute = WwwIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WwwRouteRoute
          })
const WwwSplatRoute = WwwSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => WwwRouteRoute
          })
const WwwDotinternalRouteRoute = WwwDotinternalRouteRouteImport.update({
            id: '/.internal',path: '/.internal',getParentRoute: () => WwwRouteRoute
          })
const WwwAboutUsRoute = WwwAboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => WwwRouteRoute
          })
const WwwContactRoute = WwwContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => WwwRouteRoute
          })
const WwwCookiesRoute = WwwCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => WwwRouteRoute
          })
const WwwFaqRoute = WwwFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => WwwRouteRoute
          })
const WwwLegalDisclaimerRoute = WwwLegalDisclaimerRouteImport.update({
            id: '/legal-disclaimer',path: '/legal-disclaimer',getParentRoute: () => WwwRouteRoute
          })
const WwwLiveCounterRoute = WwwLiveCounterRouteImport.update({
            id: '/live-counter',path: '/live-counter',getParentRoute: () => WwwRouteRoute
          })
const WwwPartnerNgosRoute = WwwPartnerNgosRouteImport.update({
            id: '/partner-ngos',path: '/partner-ngos',getParentRoute: () => WwwRouteRoute
          })
const WwwPrivacyPolicyRoute = WwwPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => WwwRouteRoute
          })
const WwwSelectionCriteriaRoute = WwwSelectionCriteriaRouteImport.update({
            id: '/selection-criteria',path: '/selection-criteria',getParentRoute: () => WwwRouteRoute
          })
const WwwSolutionsRoute = WwwSolutionsRouteImport.update({
            id: '/solutions',path: '/solutions',getParentRoute: () => WwwRouteRoute
          })
const PortalIdCampaignIdIndexRoute = PortalIdCampaignIdIndexRouteImport.update({
            id: '/$campaignId/',path: '/$campaignId/',getParentRoute: () => PortalIdRouteRoute
          })
const PortalIdCampaignIdDonateRoute = PortalIdCampaignIdDonateRouteImport.update({
            id: '/$campaignId/donate',path: '/$campaignId/donate',getParentRoute: () => PortalIdRouteRoute
          })
const NgosOnboardingIndexRoute = NgosOnboardingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NgosOnboardingRouteRoute
          })
const NgosOnboardingAccreditationRoute = NgosOnboardingAccreditationRouteImport.update({
            id: '/accreditation',path: '/accreditation',getParentRoute: () => NgosOnboardingRouteRoute
          })
const NgosOnboardingContactsRoute = NgosOnboardingContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => NgosOnboardingRouteRoute
          })
const NgosOnboardingPrivacyRoute = NgosOnboardingPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => NgosOnboardingRouteRoute
          })
const NgosOnboardingSuccessRoute = NgosOnboardingSuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => NgosOnboardingRouteRoute
          })
const NgosOnboardingTermsRoute = NgosOnboardingTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => NgosOnboardingRouteRoute
          })
const NgosPortalsIndexRoute = NgosPortalsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NgosPortalsRouteRoute
          })
const NgosPortalsPortalIdRouteRoute = NgosPortalsPortalIdRouteRouteImport.update({
            id: '/$portalId',path: '/$portalId',getParentRoute: () => NgosPortalsRouteRoute
          })
const NgosProjectsIndexRoute = NgosProjectsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NgosProjectsRouteRoute
          })
const NgosProjectsProjectIdRoute = NgosProjectsProjectIdRouteImport.update({
            id: '/$projectId',path: '/$projectId',getParentRoute: () => NgosProjectsRouteRoute
          })
const NgosProjectsNewRouteRoute = NgosProjectsNewRouteRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => NgosProjectsRouteRoute
          })
const WwwDotinternalArchitectureRoute = WwwDotinternalArchitectureRouteImport.update({
            id: '/architecture',path: '/architecture',getParentRoute: () => WwwDotinternalRouteRoute
          })
const WwwDotinternalBumpRoute = WwwDotinternalBumpRouteImport.update({
            id: '/bump',path: '/bump',getParentRoute: () => WwwDotinternalRouteRoute
          })
const WwwDotinternalCounterRoute = WwwDotinternalCounterRouteImport.update({
            id: '/counter',path: '/counter',getParentRoute: () => WwwDotinternalRouteRoute
          })
const WwwDotinternalToastRoute = WwwDotinternalToastRouteImport.update({
            id: '/toast',path: '/toast',getParentRoute: () => WwwDotinternalRouteRoute
          })
const WwwContactIndexRoute = WwwContactIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WwwContactRoute
          })
const WwwContactAudienceRoute = WwwContactAudienceRouteImport.update({
            id: '/$audience',path: '/$audience',getParentRoute: () => WwwContactRoute
          })
const WwwPartnerNgosIndexRoute = WwwPartnerNgosIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WwwPartnerNgosRoute
          })
const WwwPartnerNgosNgoIdRoute = WwwPartnerNgosNgoIdRouteImport.update({
            id: '/$ngoId',path: '/$ngoId',getParentRoute: () => WwwPartnerNgosRoute
          })
const PortalIdCampaignIdDonateIndexRoute = PortalIdCampaignIdDonateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortalIdCampaignIdDonateRoute
          })
const PortalIdCampaignIdDonateCheckoutRoute = PortalIdCampaignIdDonateCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => PortalIdCampaignIdDonateRoute
          })
const PortalIdCampaignIdDonateDetailsRoute = PortalIdCampaignIdDonateDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => PortalIdCampaignIdDonateRoute
          })
const PortalIdCampaignIdDonateThanksRoute = PortalIdCampaignIdDonateThanksRouteImport.update({
            id: '/thanks',path: '/thanks',getParentRoute: () => PortalIdCampaignIdDonateRoute
          })
const NgosContractsContractIdSignRoute = NgosContractsContractIdSignRouteImport.update({
            id: '/contracts/$contractId/sign',path: '/contracts/$contractId/sign',getParentRoute: () => NgosRouteRoute
          })
const NgosPortalsPortalIdIndexRoute = NgosPortalsPortalIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NgosPortalsPortalIdRouteRoute
          })
const NgosPortalsPortalIdSetupRouteRoute = NgosPortalsPortalIdSetupRouteRouteImport.update({
            id: '/$portalId_/setup',path: '/$portalId/setup',getParentRoute: () => NgosPortalsRouteRoute
          })
const NgosProjectsNewIndexRoute = NgosProjectsNewIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NgosProjectsNewRouteRoute
          })
const NgosProjectsNewBasicRoute = NgosProjectsNewBasicRouteImport.update({
            id: '/basic',path: '/basic',getParentRoute: () => NgosProjectsNewRouteRoute
          })
const NgosProjectsNewDetailsRoute = NgosProjectsNewDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => NgosProjectsNewRouteRoute
          })
const NgosProjectsNewFundingDetailsRoute = NgosProjectsNewFundingDetailsRouteImport.update({
            id: '/funding-details',path: '/funding-details',getParentRoute: () => NgosProjectsNewRouteRoute
          })
const NgosProjectsNewFundingTypeRoute = NgosProjectsNewFundingTypeRouteImport.update({
            id: '/funding-type',path: '/funding-type',getParentRoute: () => NgosProjectsNewRouteRoute
          })
const NgosProjectsNewSuccessRoute = NgosProjectsNewSuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => NgosProjectsNewRouteRoute
          })
const WwwContactAudienceIndexRoute = WwwContactAudienceIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WwwContactAudienceRoute
          })
const WwwContactAudienceTabRoute = WwwContactAudienceTabRouteImport.update({
            id: '/$tab',path: '/$tab',getParentRoute: () => WwwContactAudienceRoute
          })
const NgosPortalsPortalIdProjectsProjectIdRoute = NgosPortalsPortalIdProjectsProjectIdRouteImport.update({
            id: '/$portalId_/projects/$projectId',path: '/$portalId/projects/$projectId',getParentRoute: () => NgosPortalsRouteRoute
          })
const NgosPortalsPortalIdProjectsNewRouteRoute = NgosPortalsPortalIdProjectsNewRouteRouteImport.update({
            id: '/$portalId_/projects/new',path: '/$portalId/projects/new',getParentRoute: () => NgosPortalsRouteRoute
          })
const NgosPortalsPortalIdSetupIndexRoute = NgosPortalsPortalIdSetupIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NgosPortalsPortalIdSetupRouteRoute
          })
const NgosPortalsPortalIdSetupDetailsRoute = NgosPortalsPortalIdSetupDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => NgosPortalsPortalIdSetupRouteRoute
          })
const NgosPortalsPortalIdSetupExtrasRoute = NgosPortalsPortalIdSetupExtrasRouteImport.update({
            id: '/extras',path: '/extras',getParentRoute: () => NgosPortalsPortalIdSetupRouteRoute
          })
const NgosPortalsPortalIdSetupFundingRoute = NgosPortalsPortalIdSetupFundingRouteImport.update({
            id: '/funding',path: '/funding',getParentRoute: () => NgosPortalsPortalIdSetupRouteRoute
          })
const NgosPortalsPortalIdSetupSuccessRoute = NgosPortalsPortalIdSetupSuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => NgosPortalsPortalIdSetupRouteRoute
          })
const NgosPortalsPortalIdProjectsNewIndexRoute = NgosPortalsPortalIdProjectsNewIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NgosPortalsPortalIdProjectsNewRouteRoute
          })
const NgosPortalsPortalIdProjectsNewBasicRoute = NgosPortalsPortalIdProjectsNewBasicRouteImport.update({
            id: '/basic',path: '/basic',getParentRoute: () => NgosPortalsPortalIdProjectsNewRouteRoute
          })
const NgosPortalsPortalIdProjectsNewDetailsRoute = NgosPortalsPortalIdProjectsNewDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => NgosPortalsPortalIdProjectsNewRouteRoute
          })
const NgosPortalsPortalIdProjectsNewFundingDetailsRoute = NgosPortalsPortalIdProjectsNewFundingDetailsRouteImport.update({
            id: '/funding-details',path: '/funding-details',getParentRoute: () => NgosPortalsPortalIdProjectsNewRouteRoute
          })
const NgosPortalsPortalIdProjectsNewSuccessRoute = NgosPortalsPortalIdProjectsNewSuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => NgosPortalsPortalIdProjectsNewRouteRoute
          })





const PortalIdCampaignIdDonateRouteChildren = {
  PortalIdCampaignIdDonateCheckoutRoute: PortalIdCampaignIdDonateCheckoutRoute,PortalIdCampaignIdDonateDetailsRoute: PortalIdCampaignIdDonateDetailsRoute,PortalIdCampaignIdDonateThanksRoute: PortalIdCampaignIdDonateThanksRoute,PortalIdCampaignIdDonateIndexRoute: PortalIdCampaignIdDonateIndexRoute
}

const PortalIdCampaignIdDonateRouteWithChildren = PortalIdCampaignIdDonateRoute._addFileChildren(PortalIdCampaignIdDonateRouteChildren)



const PortalIdRouteRouteChildren = {
  PortalIdLegalDisclaimerRoute: PortalIdLegalDisclaimerRoute,PortalIdPrivacyPolicyRoute: PortalIdPrivacyPolicyRoute,PortalIdIndexRoute: PortalIdIndexRoute,PortalIdCampaignIdDonateRoute: PortalIdCampaignIdDonateRouteWithChildren,PortalIdCampaignIdIndexRoute: PortalIdCampaignIdIndexRoute
}

const PortalIdRouteRouteWithChildren = PortalIdRouteRoute._addFileChildren(PortalIdRouteRouteChildren)




const NgosOnboardingRouteRouteChildren = {
  NgosOnboardingAccreditationRoute: NgosOnboardingAccreditationRoute,NgosOnboardingContactsRoute: NgosOnboardingContactsRoute,NgosOnboardingPrivacyRoute: NgosOnboardingPrivacyRoute,NgosOnboardingSuccessRoute: NgosOnboardingSuccessRoute,NgosOnboardingTermsRoute: NgosOnboardingTermsRoute,NgosOnboardingIndexRoute: NgosOnboardingIndexRoute
}

const NgosOnboardingRouteRouteWithChildren = NgosOnboardingRouteRoute._addFileChildren(NgosOnboardingRouteRouteChildren)




const NgosPortalsPortalIdRouteRouteChildren = {
  NgosPortalsPortalIdIndexRoute: NgosPortalsPortalIdIndexRoute
}

const NgosPortalsPortalIdRouteRouteWithChildren = NgosPortalsPortalIdRouteRoute._addFileChildren(NgosPortalsPortalIdRouteRouteChildren)




const NgosPortalsPortalIdSetupRouteRouteChildren = {
  NgosPortalsPortalIdSetupDetailsRoute: NgosPortalsPortalIdSetupDetailsRoute,NgosPortalsPortalIdSetupExtrasRoute: NgosPortalsPortalIdSetupExtrasRoute,NgosPortalsPortalIdSetupFundingRoute: NgosPortalsPortalIdSetupFundingRoute,NgosPortalsPortalIdSetupSuccessRoute: NgosPortalsPortalIdSetupSuccessRoute,NgosPortalsPortalIdSetupIndexRoute: NgosPortalsPortalIdSetupIndexRoute
}

const NgosPortalsPortalIdSetupRouteRouteWithChildren = NgosPortalsPortalIdSetupRouteRoute._addFileChildren(NgosPortalsPortalIdSetupRouteRouteChildren)




const NgosPortalsPortalIdProjectsNewRouteRouteChildren = {
  NgosPortalsPortalIdProjectsNewBasicRoute: NgosPortalsPortalIdProjectsNewBasicRoute,NgosPortalsPortalIdProjectsNewDetailsRoute: NgosPortalsPortalIdProjectsNewDetailsRoute,NgosPortalsPortalIdProjectsNewFundingDetailsRoute: NgosPortalsPortalIdProjectsNewFundingDetailsRoute,NgosPortalsPortalIdProjectsNewSuccessRoute: NgosPortalsPortalIdProjectsNewSuccessRoute,NgosPortalsPortalIdProjectsNewIndexRoute: NgosPortalsPortalIdProjectsNewIndexRoute
}

const NgosPortalsPortalIdProjectsNewRouteRouteWithChildren = NgosPortalsPortalIdProjectsNewRouteRoute._addFileChildren(NgosPortalsPortalIdProjectsNewRouteRouteChildren)



const NgosPortalsRouteRouteChildren = {
  NgosPortalsPortalIdRouteRoute: NgosPortalsPortalIdRouteRouteWithChildren,NgosPortalsIndexRoute: NgosPortalsIndexRoute,NgosPortalsPortalIdSetupRouteRoute: NgosPortalsPortalIdSetupRouteRouteWithChildren,NgosPortalsPortalIdProjectsNewRouteRoute: NgosPortalsPortalIdProjectsNewRouteRouteWithChildren,NgosPortalsPortalIdProjectsProjectIdRoute: NgosPortalsPortalIdProjectsProjectIdRoute
}

const NgosPortalsRouteRouteWithChildren = NgosPortalsRouteRoute._addFileChildren(NgosPortalsRouteRouteChildren)




const NgosProjectsNewRouteRouteChildren = {
  NgosProjectsNewBasicRoute: NgosProjectsNewBasicRoute,NgosProjectsNewDetailsRoute: NgosProjectsNewDetailsRoute,NgosProjectsNewFundingDetailsRoute: NgosProjectsNewFundingDetailsRoute,NgosProjectsNewFundingTypeRoute: NgosProjectsNewFundingTypeRoute,NgosProjectsNewSuccessRoute: NgosProjectsNewSuccessRoute,NgosProjectsNewIndexRoute: NgosProjectsNewIndexRoute
}

const NgosProjectsNewRouteRouteWithChildren = NgosProjectsNewRouteRoute._addFileChildren(NgosProjectsNewRouteRouteChildren)



const NgosProjectsRouteRouteChildren = {
  NgosProjectsNewRouteRoute: NgosProjectsNewRouteRouteWithChildren,NgosProjectsProjectIdRoute: NgosProjectsProjectIdRoute,NgosProjectsIndexRoute: NgosProjectsIndexRoute
}

const NgosProjectsRouteRouteWithChildren = NgosProjectsRouteRoute._addFileChildren(NgosProjectsRouteRouteChildren)



const NgosRouteRouteChildren = {
  NgosOnboardingRouteRoute: NgosOnboardingRouteRouteWithChildren,NgosPortalsRouteRoute: NgosPortalsRouteRouteWithChildren,NgosProjectsRouteRoute: NgosProjectsRouteRouteWithChildren,NgosDashboardRoute: NgosDashboardRoute,NgosFaqRoute: NgosFaqRoute,NgosLoginRoute: NgosLoginRoute,NgosResourcesRoute: NgosResourcesRoute,NgosSelectNgoRoute: NgosSelectNgoRoute,NgosSettingsRoute: NgosSettingsRoute,NgosIndexRoute: NgosIndexRoute,NgosContractsContractIdSignRoute: NgosContractsContractIdSignRoute
}

const NgosRouteRouteWithChildren = NgosRouteRoute._addFileChildren(NgosRouteRouteChildren)




const OldRouteRouteChildren = {
  OldSplatRoute: OldSplatRoute,OldAboutUsRoute: OldAboutUsRoute,OldContactRoute: OldContactRoute,OldCookiesRoute: OldCookiesRoute,OldLegalDisclaimerRoute: OldLegalDisclaimerRoute,OldPrivacyPolicyRoute: OldPrivacyPolicyRoute,OldRoundUpRoute: OldRoundUpRoute,OldSelectionCriteriaRoute: OldSelectionCriteriaRoute,OldTransparencyRoute: OldTransparencyRoute,OldIndexRoute: OldIndexRoute
}

const OldRouteRouteWithChildren = OldRouteRoute._addFileChildren(OldRouteRouteChildren)




const WwwDotinternalRouteRouteChildren = {
  WwwDotinternalArchitectureRoute: WwwDotinternalArchitectureRoute,WwwDotinternalBumpRoute: WwwDotinternalBumpRoute,WwwDotinternalCounterRoute: WwwDotinternalCounterRoute,WwwDotinternalToastRoute: WwwDotinternalToastRoute
}

const WwwDotinternalRouteRouteWithChildren = WwwDotinternalRouteRoute._addFileChildren(WwwDotinternalRouteRouteChildren)




const WwwContactAudienceRouteChildren = {
  WwwContactAudienceTabRoute: WwwContactAudienceTabRoute,WwwContactAudienceIndexRoute: WwwContactAudienceIndexRoute
}

const WwwContactAudienceRouteWithChildren = WwwContactAudienceRoute._addFileChildren(WwwContactAudienceRouteChildren)



const WwwContactRouteChildren = {
  WwwContactAudienceRoute: WwwContactAudienceRouteWithChildren,WwwContactIndexRoute: WwwContactIndexRoute
}

const WwwContactRouteWithChildren = WwwContactRoute._addFileChildren(WwwContactRouteChildren)




const WwwPartnerNgosRouteChildren = {
  WwwPartnerNgosNgoIdRoute: WwwPartnerNgosNgoIdRoute,WwwPartnerNgosIndexRoute: WwwPartnerNgosIndexRoute
}

const WwwPartnerNgosRouteWithChildren = WwwPartnerNgosRoute._addFileChildren(WwwPartnerNgosRouteChildren)



const WwwRouteRouteChildren = {
  WwwDotinternalRouteRoute: WwwDotinternalRouteRouteWithChildren,WwwSplatRoute: WwwSplatRoute,WwwAboutUsRoute: WwwAboutUsRoute,WwwContactRoute: WwwContactRouteWithChildren,WwwCookiesRoute: WwwCookiesRoute,WwwFaqRoute: WwwFaqRoute,WwwLegalDisclaimerRoute: WwwLegalDisclaimerRoute,WwwLiveCounterRoute: WwwLiveCounterRoute,WwwPartnerNgosRoute: WwwPartnerNgosRouteWithChildren,WwwPrivacyPolicyRoute: WwwPrivacyPolicyRoute,WwwSelectionCriteriaRoute: WwwSelectionCriteriaRoute,WwwSolutionsRoute: WwwSolutionsRoute,WwwIndexRoute: WwwIndexRoute
}

const WwwRouteRouteWithChildren = WwwRouteRoute._addFileChildren(WwwRouteRouteChildren)

const rootRouteChildren = {
  PortalIdRouteRoute: PortalIdRouteRouteWithChildren,NgosRouteRoute: NgosRouteRouteWithChildren,OldRouteRoute: OldRouteRouteWithChildren,WwwRouteRoute: WwwRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)